<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button icon="sync" @click="apiProductStatistics">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="售票统计查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">产品：</div>
						<a-select 
							mode="multiple" 
							v-model="query.productIds" 
							placeholder="请选择产品" 
							style="width: 100%"
						>
							<a-select-option :value="1">窗口票</a-select-option>
							<a-select-option :value="2">网络票</a-select-option>
							<a-select-option :value="3">携程扫码票</a-select-option>
						</a-select>
						<a-button style="margin: 3px " type="danger" @click="resetFields">清空</a-button>
					</div>
					
					
					<div class="qinang-search-col-3" v-if="query.reportType == 1">
						<div class="qinang-search-col-title">查询日期：</div>
						<a-date-picker 
							v-model="query.startDay" 
							valueFormat="YYYY-MM-DD" 
							format="YYYY-MM-DD" 
							class="qinang-search-time-picker-2" 
						/>
						<span style="width: 20px;text-align: center;">-</span>
						<a-date-picker 
							v-model="query.endDay" 
							valueFormat="YYYY-MM-DD" 
							format="YYYY-MM-DD" 
							class="qinang-search-time-picker-2" 
						/>	
					</div>
					
					<div class="qinang-search-col-3" v-if="query.reportType == 2">
						<div class="qinang-search-col-title">查询日期：</div>
						<a-month-picker 
							v-model="query.startMonth" 
							valueFormat="YYYY-MM" 
							format="YYYY-MM" 
							class="qinang-search-time-picker-2" 
						/>
						<span style="width: 20px;text-align: center;">-</span>
						<a-month-picker 
							v-model="query.endMonth" 
							valueFormat="YYYY-MM" 
							format="YYYY-MM" 
							class="qinang-search-time-picker-2" 
						/>
					</div>
					
					<div class="qinang-search-col-3" v-if="query.reportType == 3">
						<div class="qinang-search-col-title">查询日期：</div>
						<a-select v-model="query.startYear" class="qinang-search-select-2">
							<a-select-option v-for="(item, index) in yearList" :key="index" :value="item">
								{{item}}
							</a-select-option>
						</a-select>
					</div>

					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">日期依据：</div>
						<a-radio-group v-model="query.dateType" style="margin-left: 14px;">
							<a-radio :value="1">售票日期</a-radio>
							<a-radio :value="2">检票日期</a-radio>
							</a-radio-group>
					</div>
					<div style="flex: 0 0 100%; height: 0;"></div>
					
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">报表类型：</div>
						<a-radio-group v-model="query.reportType" style="margin-left: 14px;">
							<a-radio :value="1">日报表</a-radio>
							<a-radio :value="2">月报表</a-radio>
							<a-radio :value="3">年报表</a-radio>
						</a-radio-group>
					</div>
				</div>
				
				<div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
					<a-button type="primary" icon="search" @click="apiProductStatistics">查询</a-button>
					<a-button icon="redo" @click="resetQuery" style="margin-left: 14px;">重置</a-button>
					<a-button type="primary" icon="download" @click="dowTable" style="margin-left: 14px;">导出</a-button>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			 <a-spin :spinning="tableLoading">
			<div style="width: 100%;text-align: center;margin: 20px;font-size: 16px;">产品统计表</div>
			<div style="margin: 0 40px 20px;text-align: right;">
				<span> {{ queryDate }} </span>
				<span style="margin-left: 20px;">报表类型：{{ queryType }}</span>
			</div>
			<div style="margin: 20px 40px;overflow-x: auto;">
				<table id="reportTable" class="qa-ticket-sales-table" style="width: 100%;border-collapse: collapse;">
					<thead>
						<tr>
							<th class="qa-th-merged">日期</th>
							<th class="qa-th-merged">产品名称</th>
							<th class="qa-th-merged">人群</th>
							<th class="qa-th-merged">单价(元)</th>
							<th class="qa-th-merged">数量</th>
							<th class="qa-th-merged">金额(元)</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(tr, index) in tableData" :key="index">
							<template v-for="(td, tdIndex) in tr.tr">
								<td 
									v-if="td.colspan > 0" 
									:key="tdIndex"
									:rowspan="td.rowspan" 
									:colspan="td.colspan" 
									:class="td.class"
								>
									{{ td.value }}
								</td>
							</template>
						</tr>
					</tbody>
				</table>
			</div>
			<div style="margin: 20px 40px;text-align: right;">
				<span>制表人：{{ staffName }}</span>
				<span style="margin-left: 20px;">打印时间：{{ moment().format('YYYY-MM-DD HH:mm:ss') }}</span>
			</div>
			</a-spin>
		</div>
	</div>
</template>

<script>
	import FileSaver from 'file-saver'
	import * as XLSX from 'xlsx'
	import moment from 'moment'
	import { parseProductTableData } from './ProductReportUtil'
	
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				staffName: window.sessionStorage.getItem('staffName') || '测试',
				tableLoading: false,
				queryDate: '',
				queryType: '',
				yearList: [2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030],
				
				query: {
					productIds: [],      // 替换 ticketTypes
					startDay: null,
					endDay: null,
					startMonth: null,
					endMonth: null,
					startYear: moment().format('YYYY'),
					reportType: 1,
					dateType: 1,
				},
				
				apiReturnData: {
					statisticsList: [],
					priceList: [],
					saleList: [],
					refundList: []
				},
				
				tableData: []
			}
		},
		
		methods: {
			parseTable() {
				if (this.apiReturnData && this.apiReturnData.statisticsList) {
					this.tableData = parseProductTableData(this.apiReturnData)
				} else {
					this.tableData = []
				}
			},
			
			async apiProductStatistics() {
				// 参数校验
				if (this.query.reportType == 1 && (!this.query.startDay || !this.query.endDay)) {
					this.$message.warning('请选择查询日期')
					return
				}
				if (this.query.reportType == 2 && (!this.query.startMonth || !this.query.endMonth)) {
					this.$message.warning('请选择查询月份')
					return
				}
				
				let params = {
					staffId: window.sessionStorage.getItem('staffId'),
					reportType: this.query.reportType,
					productIds: this.query.productIds,   // 关键：传递产品ID数组
					dateType: this.query.dateType
				}
				
				switch (this.query.reportType) {
					case 1:
						params.startDay = moment(this.query.startDay).startOf('day').format('YYYY-MM-DD HH:mm:ss')
						params.endDay = moment(this.query.endDay).endOf('day').format('YYYY-MM-DD HH:mm:ss')
						break
					case 2:
						params.startMonth = moment(this.query.startMonth).startOf('month').format('YYYY-MM-DD HH:mm:ss')
						params.endMonth = moment(this.query.endMonth).endOf('month').format('YYYY-MM-DD HH:mm:ss')
						break
					case 3:
						params.startYear = this.query.startYear
						break
				}
				
				this.tableLoading = true
				try {
					const { data: res } = await this.$http.post(this.navigation.apiProductStatistics, params)
					if (res.code == 200) {
						this.apiReturnData = {
							statisticsList: res.data.statisticsList || [],
							priceList: res.data.priceList || [],
							saleList: res.data.saleList || [],
							refundList: res.data.refundList || []
						}
						this.parseTable()
						this.setQueryDisplayInfo()
					} else {
						this.$message.error(res.msg || '查询失败')
					}
				} catch (error) {
					console.error('查询失败:', error)
					this.$message.error('网络异常，请稍后重试')
				} finally {
					this.tableLoading = false
				}
			},
			
			// 设置查询结果显示信息
			setQueryDisplayInfo() {
				switch (this.query.reportType) {
					case 1:
						if (this.query.startDay && this.query.endDay) {
							this.queryDate = moment(this.query.startDay).format('YYYY-MM-DD') + ' 至 ' + moment(this.query.endDay).format('YYYY-MM-DD')
						}
						this.queryType = '日报表'
						break
					case 2:
						if (this.query.startMonth && this.query.endMonth) {
							this.queryDate = moment(this.query.startMonth).format('YYYY-MM') + ' 至 ' + moment(this.query.endMonth).format('YYYY-MM')
						}
						this.queryType = '月报表'
						break
					case 3:
						this.queryDate = this.query.startYear + '年'
						this.queryType = '年报表'
						break
				}
			},
			async apiGetProductList() {
				try {
					const { data: res } = await this.$http.post(this.navigation.apiProductList, {
						staffId: window.sessionStorage.getItem('staffId')
					})
					if (res.code == 200) {
						this.productList = res.data || []
					}
				} catch (error) {
					console.error('获取产品列表失败', error)
				}
			},
			
			// 清空票种
			resetFields(){
				this.query.productIds = [];
			},
			
			// 重置查询条件
			resetQuery() {
				this.query = {
					productIds: [],
					startDay: moment().format('YYYY-MM-DD'),
					endDay: moment().format('YYYY-MM-DD'),
					startMonth: moment().format('YYYY-MM'),
					endMonth: moment().format('YYYY-MM'),
					startYear: moment().format('YYYY'),
					reportType: 1,
					dateType: 1,
				}
				// 重新查询
				this.apiProductStatistics()
			},
			
			// 导出表格
			dowTable() {
				if (!XLSX || !XLSX.utils || !XLSX.write) {
					console.error('XLSX library not loaded')
					this.$message.error('导出组件加载失败')
					return
				}
				
				try {
					const tableDom = document.getElementById("reportTable")
					if (!tableDom) {
						this.$message.error('未找到表格数据')
						return
					}
					
					const workbook = XLSX.utils.table_to_book(tableDom)
					const excelData = XLSX.write(workbook, {
						bookType: "xlsx",
						bookSST: true,
						type: "array"
					})
					
					const fileName = `产品统计报表_${this.queryDate || moment().format('YYYY-MM-DD')}.xlsx`
					FileSaver.saveAs(
						new Blob([excelData], { type: "application/octet-stream" }),
						fileName
					)
					this.$message.success('导出成功')
				} catch (error) {
					console.error('导出失败:', error)
					this.$message.error('导出失败')
				}
			}


		},
		
		created() {
			// 设置默认日期
			this.query.startDay = moment().format('YYYY-MM-DD')
			this.query.endDay = moment().format('YYYY-MM-DD')
			this.query.startMonth = moment().format('YYYY-MM')
			this.query.endMonth = moment().format('YYYY-MM')
			
			// 初始化数据
			this.apiProductStatistics()
		}
	}
</script>

<style scoped>
	.qa-ticket-sales-table {
		border: 1px solid #000;
		border-collapse: collapse;
		width: 100%;
	}
	
	.qa-th-merged {
		text-align: center;
		border: 1px solid #000;
		background-color: #d3e0f0;
		padding: 8px;
		font-weight: bold;
	}
	
	.qa-td-normal {
		text-align: center;
		border: 1px solid #000;
		padding: 6px;
	}
	
	.qa-td-subtotal {
		text-align: center;
		border: 1px solid #000;
		padding: 6px;
		background-color: #e7edf4;
		font-weight: bold;
	}
	
	.qa-td-total {
		text-align: center;
		border: 1px solid #000;
		padding: 6px;
		background-color: #e0e7f3;
		font-weight: bold;
	}
	
	.qinang-search-row {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		margin-bottom: 12px;
	}
	
	.qinang-search-col-3 {
		flex: 0 0 25%;
		display: flex;
		align-items: center;
		padding: 0 8px;
		margin-bottom: 12px;
	}
	
	.qinang-search-col-title {
		white-space: nowrap;
		margin-right: 8px;
	}
	
	.qinang-search-time-picker-2 {
		flex: 1;
	}
	
	.qinang-search-select-2 {
		flex: 1;
	}
	
	.qinang-margin-top-12 {
		margin-top: 12px;
	}
	
	.qinang-card {
		background: #fff;
		margin-top: 16px;
		padding: 16px;
		border-radius: 4px;
	}
</style>